import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import { DiffProps } from "./useDiffComponentFactory";
import { useTranslation } from "react-i18next";

export default function DoyDiffComponent({ diff }: DiffProps) {
  const { t } = useTranslation();

  return (
    <Box sx={{ width: "100%", maxWidth: 1000, mx: "auto", my: 4 }}>
      <TableContainer component={Paper} elevation={0}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  width: "20%",
                  borderBottom: "1px solid rgba(224, 224, 224, 1)",
                }}
              ></TableCell>
              <TableCell
                align="center"
                sx={{
                  color: "darkgreen",
                  fontWeight: "bold",
                  borderBottom: "1px solid rgba(224, 224, 224, 1)",
                }}
              >
                  {t("Μητρώο Γ.Ε.ΜΗ.")}
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  color: "darkgreen",
                  fontWeight: "bold",
                  borderBottom: "1px solid rgba(224, 224, 224, 1)",
                }}
              >
                {t("Μητρώο ΑΑΔΕ")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row" sx={{ fontWeight: "bold" }}>
                {t("ΔΟΥ")}
              </TableCell>
              <TableCell align="center">{diff.doy.gemi}</TableCell>
              <TableCell align="center">{diff.doy.aade}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
